// src/types/calendar-event.ts
// Event 相關型別定義

// Event 時間類型
export type EventTimeType = 'timed' | 'allday';

// Event 分類
export type EventCategory = 
  | 'meeting'      // 工作會議
  | 'appointment'  // 個人預約
  | 'class'        // 課程/培訓
  | 'social'       // 社交活動
  | 'deadline'     // 截止日期
  | 'ceremony'     // 儀式/典禮
  | 'anniversary'  // 紀念日
  | 'holiday'      // 假期
  | 'competition'  // 比賽/競賽
  | 'other';

// Event 來源
export type EventSource = 'manual' | 'google_calendar' | 'outlook';

// Event 準備配置
export interface EventPreparation {
  reminderDays: number[];    // 提前提醒天數，如 [7, 3, 1]
  relatedTasks: string[];    // 相關的準備任務 ID
}

// Event 主要介面
export interface Event {
  id: string;
  itemType: 'event';         // 明確的類型標識
  userId: string;
  title: string;
  /** @deprecated 2026-02-06 限期至 2026-08-06 移除。請使用 notes */
  description?: string;
  timeType: EventTimeType;
  category: EventCategory;
  startTime: Date;
  endTime: Date;             // 所有事件都必須有 endTime
  preparation?: EventPreparation;
  source?: EventSource;
  location?: string;
  notes?: string;
  createdAt: Date;
  updatedAt?: Date;
}

// 創建 Event 請求
export type CreateEventRequest = Omit<Event, 'id' | 'createdAt' | 'updatedAt'> & {
  // 允許接收字符串格式的時間，方便前端傳遞
  startTime: Date | string;
  endTime: Date | string;  // endTime 必填
};

// 更新 Event 請求
export type UpdateEventRequest = 
  { id: string } & 
  Partial<Omit<Event, 'id' | 'createdAt' | 'updatedAt'>> & {
    // 允許接收字符串格式的時間，方便前端傳遞
    startTime?: Date | string;
    endTime?: Date | string;
  };



// Event 基礎樣式 - 統一的紅色背景強調外部承諾
export const eventBaseColors = 'bg-red-100 text-red-900';

// Event 全天樣式 - 稍微不同的視覺表現
export const alldayEventColors = 'bg-red-100 text-red-800';